import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiConnectorService } from 'src/app/_LOGIC/__api/api-connector.service';
import { GuiFlowManagerService } from 'src/app/_LOGIC/__gui/gui-flow-manager.service';

@Component({
  selector: 'app-smart-footer',
  templateUrl: './smart-footer.component.html',
  styleUrls: ['./smart-footer.component.css']
})
export class SmartFooterComponent implements OnInit {

  companyName = 'VoyJaleas';
  currentYear;

  today = null;
  showSuccessMessage = false;

  email = new FormControl('', [Validators.required, Validators.email]);

  constructor(private router: Router,private apiConnector: ApiConnectorService,private guiFlow: GuiFlowManagerService) {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var accumulate = 30*month+day;
    this.today = year + "/" + month + "/" + day;
    this.currentYear =dateObj.getUTCFullYear();
  }

  ngOnInit(): void {
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }

  subscribe() {
    if(this.email.valid){
      // Save to BBDD
      let obj = {email: this.email.value};
      this.apiConnector.newDynamicApiRequest('post', 'subscription', obj)
      .subscribe(response => this.processPostRequest(response));
      /* switch(this.guiFlow.getCurrentRoute()){
        case '/':
        case '/home':
          break;
        case '/contact':
          window.scroll(0, 0);
          break;
      } */
      /* this.guiFlow.openSimpleSnackBar(this.MESSAGE_SENT, this.MESSAGE_SENT_ICON); */
      this.showSuccessMessage = true;
    }else{
      this.guiFlow.openSimpleSnackBar('Rellena el email', 'Ok');
      console.log('MISSING FIELDS');
    }
    
  }

  processPostRequest(res){
    if(res){
      if(res.KO){
        this.guiFlow.openSimpleSnackBar('Error', 'Ok');
      }
      if(res.OK){
        this.guiFlow.openSimpleSnackBar(res.OK.message, '');
      }
    }
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'El email es obligatorio';
    }
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

}
